export default __webpack_public_path__ + "static/media/pag27.258c9223.jpg";